var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showOnly
        ? [
            _vm.dialog.status !== 1
              ? _c("span", { staticClass: "badge badge-primary" }, [
                  _vm._v(_vm._s(_vm.statuses[_vm.dialog.status]?.title)),
                ])
              : _vm._e(),
          ]
        : [
            _c("label", { staticClass: "text-muted" }, [
              _vm._v("Статус диалога"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dialog.status,
                      expression: "dialog.status",
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.dialog,
                        "status",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                _vm._l(_vm.statuses, function (s) {
                  return _c("option", { domProps: { value: s.id } }, [
                    _vm._v(_vm._s(s.title)),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              +_vm.dialog.status === 6
                ? _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.dialog.chat_data.status_comment,
                          expression: "dialog.chat_data.status_comment",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Страна" },
                      domProps: { value: _vm.dialog.chat_data.status_comment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.dialog.chat_data,
                            "status_comment",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group-append" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Сохранить",
                      type: "button",
                      loading: _vm.loading,
                      color: _vm.$constants.LOADING_COLOR,
                      onClick: () => _vm.updateStatus(),
                      className: "btn btn-outline-info",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }